import React, { useEffect, useState } from 'react';
import styles from '../styles/termsOfUse.module.scss';
import { collection, getDocs } from "firebase/firestore";
import {db} from '../config/firebase';

function TermsOfUseEn() {
    const [termsOfUse, setTermsOfUse] = useState(null);

    useEffect(() => {
        fetchPost()
    }, [])

    const fetchPost = async () => {
       console.log('BURDA')
       const usersCollectionRef = collection(db, "Contracts");
        getDocs(usersCollectionRef)
            .then((querySnapshot)=>{               
                const newData = querySnapshot.docs.filter(x => x.id === 'Terms Of Use En')
                if (newData.length > 0) {
                    setTermsOfUse(newData[0].data())
                    console.log('AAA', newData[0].data())
                }
                //     .map((doc) => ({...doc.data(), id:doc.id }));              
                // console.log(newData);
            })
            .catch(e => console.error('HATA', e))
       
    }

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <div className={styles.container1}>
                    <div className={styles.container1__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(0, 31)}</p>
                    </div>
                    <br/>
                    <div className={styles.container1__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(32, 46)}</p>
                    </div>
                    <div className={styles.container1__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(47, 96)}</p>
                    </div>
                </div>
               
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(97, 1224)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(1225, 1816)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(1817, 1931)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(1932, 2291)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(2292, 2944)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(2945, 2992)}</p>
                    </div>
                </div>
                    
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(2993, 3492)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(3493, 3683)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(3684, 3920)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(3921, 4135)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4136, 4274)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4275, 4497)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4498, 4622)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4623, 4704)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4705, 4784)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4785, 4994)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4995, 5236)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5237, 6747)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(6748, 7435)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(7436, 8212)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(8213, 9183)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(9184, 9532)}</p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        {/* <p>Kullanıcı içeriği ve intekarktif</p> */}
                        <p>{termsOfUse != null && termsOfUse.content.substring(9533, 9552)}</p>
                    </div>
                </div>
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(9552, 9736)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(9737, 10211)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(10212, 10218)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(10219, 10527)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(10528, 11160)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11161, 11503)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11504, 11915)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11916, 12262)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(12262, 12673)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(12673, 12822)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(12822, 13130)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(13131, 13795)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(13796, 13926)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(13927, 14158)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(14159, 14498)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(14499, 14703)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(14704, 15058)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(15059, 15667)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(15668, 16061)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16062, 16397)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16397, 16647)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16648, 16823)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16823, 17090)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(17090, 17411)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(17412, 18049)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18049, 18226)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18227, 18497)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18497, 18658)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18659, 18817)}</p>
                        <br/>
                    </div>
                </div>
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text2}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18817, 18859)}</p>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
      
    )
}

export default TermsOfUseEn;